import { Outlet } from 'react-router-dom'
import { Header } from './Header/Header'
import { AgentConfigureTabs } from './AgentConfigureTabs/AgentConfigureTabs'
import styles from './styles.module.scss'

export const UnifiedAgentContent = () => (
  <>
    <Header />
    <div className={styles.wrap}>
      <div className={styles.left}>
        <div className={styles.tabsRow}>
          <AgentConfigureTabs />
        </div>
        <div className={styles.content}>
          <Outlet />
        </div>
      </div>
      <div className={styles.right} />
    </div>
  </>
)
